// removed by extract-text-webpack-plugin
module.exports = {"root":"_3cjyW","noPadding":"_1Qs0S"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/PaymentMethodLayout/PaymentMethodLayout.scss
// module id = 207
// module chunks = 0 1